import { request } from '../lib/request';
import type { ApiRequestBody, BindSbpToken, BindSbpTokenParams } from '../types';

const createPayload = (params: BindSbpTokenParams): ApiRequestBody => {
    return params.purchaseToken
        ? {
              purchase_token: params.purchaseToken,
          }
        : {};
};

export const bindSbpTokenApi = async (apiHost: string, params: BindSbpTokenParams) => {
    const payload = createPayload(params);

    const response = await request<BindSbpToken>({
        method: 'POST',
        url: `${apiHost}/web/bind_sbp_token`,
        params: payload,
        body: payload,
    });

    return response.form_url;
};
